import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { ExamCallService } from '../../../../../../services/exam-call/exam-call.service';
import { ExamCallDialogData } from './exam-call-dialog-data';
import { ExamCall } from '../../../../../../models/exam-calls/exam-call';


@Component({
    selector: 'fuse-add-edit-exam-call',
    templateUrl: './add-edit-exam-call.component.html',
    styleUrls: ['./add-edit-exam-call.component.scss']
})
export class AddEditExamCallComponent implements OnInit {
    @BlockUI('tracker-dialog') blockUI: NgBlockUI;
    examCallForm: FormGroup;
    months: any[] = [
        { id: 1, name: 'MONTHS.JANUARY' },
        { id: 2, name: 'MONTHS.FEBRUARY' },
        { id: 3, name: 'MONTHS.MARCH' },
        { id: 4, name: 'MONTHS.APRIL' },
        { id: 5, name: 'MONTHS.MAY' },
        { id: 6, name: 'MONTHS.JUNE' },
        { id: 7, name: 'MONTHS.JULY' },
        { id: 8, name: 'MONTHS.AUGUST' },
        { id: 9, name: 'MONTHS.SEPTEMBER' },
        { id: 10, name: 'MONTHS.OCTOBER' },
        { id: 11, name: 'MONTHS.NOVEMBER' },
        { id: 12, name: 'MONTHS.DECEMBER' }
    ];
    callNumbers: any[] = [
        { id: 1, name: 'CALL_NUMBERS.FIRST' },
        { id: 2, name: 'CALL_NUMBERS.SECOND' },
        { id: 3, name: 'CALL_NUMBERS.THIRD' },
        { id: 4, name: 'CALL_NUMBERS.FOURTH' },
        { id: 5, name: 'CALL_NUMBERS.FIFTH' },
        { id: 6, name: 'CALL_NUMBERS.SIXTH' },
        { id: 7, name: 'CALL_NUMBERS.SEVENTH' },
        { id: 8, name: 'CALL_NUMBERS.EIGHTH' },
        { id: 9, name: 'CALL_NUMBERS.NINTH' },
        { id: 10, name: 'CALL_NUMBERS.TENTH' }
    ];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ExamCallDialogData,
        public dialogRef: MatDialogRef<AddEditExamCallComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        private examCallService: ExamCallService
    ) {
        const currentMonth = new Date().getMonth() + 1;
        this.examCallForm = this.fb.group({
            description: [this.data.examCall.Description, [Validators.required]],
            type: [this.data.examCall.Type, [Validators.required]],
            month: [this.data.mode === 'add' ? (this.data.examCall.Month || currentMonth) : this.data.examCall.Month, [Validators.required]],
            callNumber: [this.data.examCall.CallNumber]
        });
    }

    ngOnInit() { }

    save() {
        this.blockUI.start(this.translationService.savingChanges);

        const examCall = Object.assign(this.data.examCall, this.examCallForm.value);
        examCall.SchoolYearId = this.data.schoolYearId;

        const action = this.data.mode === 'add'
            ? this.examCallService.add(examCall)
            : this.examCallService.edit(examCall);

        action.subscribe(res => {
            this.blockUI.stop();
            if (res.ResultCode === 1) {
                this.translationService.translate('LABELS.CORRECTLY_ADDED', '', (msg) => {
                    this.sweetAlertService.success(this.translationService.success, msg, null);
                });
                this.dialogRef.close(true);
            } else {
                this.sweetAlertService.error('Error', res.ResultMsg, null);
            }
        }, error => {
            this.blockUI.stop();
            this.sweetAlertService.error('Error', error, null);
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/exam-calls/components/add-edit-exam-call/add-edit-exam-call.component.ts